module.exports = __webpack_public_path__ + "img/persona-fr.40290cd4.png";